export default __webpack_public_path__ + "static/IP_Vision_Pro_02-fa7cb92cd24a2cdbf61c130fcbc618f1.webp";